import { NUMBER_OF_ARTICLES_RECS_TO_SHOW } from 'bundles/unified-description-page-common/constants';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import getArticleCategoryFilters from 'bundles/unified-description-page-common/utils/getArticleCategoryFilters';
import type { SearchParameters } from 'bundles/unified-seo-content-common/hooks/useAlgoliaQueryCSR';

function getArticleRecsSearchParameters(
  pageData: ConsumerCoursePageFieldsFragment | ConsumerSpecializationPageFieldsFragment
): SearchParameters {
  const domainId = pageData.domains?.[0]?.domainId;
  const subdomainId = pageData.domains?.[0]?.subdomainId;
  const slug = pageData.slug;
  const skills = pageData.skills;

  return {
    query: `${slug.split('-').join(' ')} ${skills || [].join(' ')}`,
    removeWordsIfNoResults: 'allOptional',
    filters: getArticleCategoryFilters(domainId, subdomainId),
    hitsPerPage: NUMBER_OF_ARTICLES_RECS_TO_SHOW,
  };
}

export default getArticleRecsSearchParameters;
